import e from"./MenuSelect.vue_vue&type=script&lang.js";import{render as t}from"./MenuSelect.vue_vue&type=template&id=11a03a77&lang.js";e.render=t;export default e;
//# sourceMappingURL=MenuSelect.vue.js.map
